import type { CSSProperties } from 'react';
import { useAnchorable } from '../../hooks/useAnchorable';
import { tableContainer } from './Table.css';
import { table } from './Table.css';
import type { TPostTableProps } from './Table.types';

export const PostTable = (props: TPostTableProps) => {
  const { element, children } = props;

  const { anchorAttributes } = useAnchorable(element.attrs);

  const cellWidth = 100 / element.content.length;

  return (
    <div
      {...anchorAttributes}
      className={tableContainer}
      style={
        {
          '--cell-width': `${cellWidth}%`,
        } as CSSProperties
      }
    >
      <table className={table}>{children}</table>
    </div>
  );
};
